import script from "./PushConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PushConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./PushConfirmModal.vue?vue&type=style&index=0&id=22de8fb4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22de8fb4"]])

export default __exports__